import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './config/locales/en.json';
import itTranslations from './config/locales/it.json';

const SUPPORTED_LANGS = ['en', 'it'];

// Bahasa awal: prioritas dari URL `?lang=` (dikirim app/web-marketer biar konsisten
// dengan bahasa app), lalu yang tersimpan di localStorage, terakhir default 'en'.
// Yang dari URL di-persist ke `skai1Language` supaya header x-lang (konten BE dari API)
// dan language switcher (PurchaseLayout) ikut konsisten sejak load pertama.
const getInitialLanguage = () => {
  try {
    const urlLang = new URLSearchParams(window.location.search).get('lang');
    if (urlLang && SUPPORTED_LANGS.includes(urlLang.toLowerCase())) {
      const lang = urlLang.toLowerCase();
      localStorage.setItem('skai1Language', lang);
      return lang;
    }
    const saved = localStorage.getItem('skai1Language');
    if (saved && SUPPORTED_LANGS.includes(saved)) return saved;
  } catch (e) {
    // window/localStorage tidak tersedia → fallback ke default
  }
  return 'en';
};

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslations },
    it: { translation: itTranslations },
  },
  lng: getInitialLanguage(),
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false
  }
});

export default i18n;